<!-- 个人中心 -->
<template>
  <div class="cont">
    <div class="banner">
      <div
        style="width: 1200px;margin: 0px auto;position: relative;display: flex;justify-content: space-between;align-items: center;">
        <p class="top-title">个人中心</p>
        <el-dropdown v-if="$store.state.name" @command="handleCommand" class="userMenu">
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;">个人中心</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix" command="Personal">
              {{ $store.state.name }}
            </el-dropdown-item>
            <el-dropdown-item class="clearfix" command="LoginOut">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-else trigger="click" class="userMenu" disabled>
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;" @click="toWeiXinLogin">登录</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
        </el-dropdown>
      </div>
    </div>
    <div class="row_menu">
      <div class="row_menu_item" @click="toPerson">基本信息</div>
      <div class="row_menu_item row_menu_item_active">我的办件</div>
      <!-- <div class="row_menu_item" @click="toMyMaterials">我的材料</div> -->
    </div>
    <el-table :data="dataShow" style="width: 100%">
      <el-table-column prop="name" label="事项名称" align="left">
      </el-table-column>
      <el-table-column prop="deptName" label="受理部门" align="left">
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="200" align="left">
      </el-table-column>
      <el-table-column label="操作" width="150" align="left">
        <template slot-scope="scope">
          <span style="cursor: pointer;color:#41A2ED" @click="toDetail(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 20px;">
      <span class="demonstration"></span>
      <el-pagination @size-change="(val) => { return handleSizeChange(val) }"
        @current-change="(val) => { return handleCurrentChange(val) }" :current-page="currentPage"
        :page-sizes="pageSizes" :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getHandlingList, logout } from "@/api/user/index";
export default {
  data() {
    return {
      List: [],     //收件数据列表
      PageData: [], //分页数据(全部数据已经分好页)
      dataShow: [], // 当前页要显示的数据
      total: 0,
      pageSize: 10,
      pageSizes: [10, 15, 20, 30, 40, 50], // select选项设置：条/页
      currentPage: 1, //当前显示页
      pageNum: 1,  //页数--最少一页
    };
  },

  mounted() {
    this.getList()
  },

  methods: {
    // 获取办件信息
    getList() {
      // handleStatus 办件状态( 0:收件 1:办结 2:退回 3:完成)
      let obj = {
        idCard: this.$store.state.idCard
      }
      if (!obj.idCard) {
        this.$message.error('未登录，请登陆后再试！')
        return
      } else {
        getHandlingList(obj).then((res) => {
          // console.log('办件列表', res);
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.length > 0) {
              this.List = res.data.data;
              this.total = this.List.length;
              this.calcPageData()
            }
          } else if (res.data.code == 1001) {
            this.$message.error('登录状态已过期，请重新登录！')
            localStorage.removeItem('userInfo');
            localStorage.removeItem('token');
            sessionStorage.removeItem('applyId');
            this.$router.push('/')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }

    },
    // 办件详情
    toDetail(row) {
      // console.log('办件',row.applyId)
      this.$router.push({
        name: 'HandlingDetails',
        params: { applyId: row.applyId }
      })
      sessionStorage.setItem('applyId', row.applyId)
    },
    // 用户下拉菜单
    handleCommand(name) {
      switch (name) {
        case 'Personal':
          this.$router.push({
            name: 'Personal'
          })
          break;
        case 'LoginOut':
          this.LoginOut()
          break;
      }
    },
    // 到微信登录
    toWeiXinLogin() {
      this.$router.push({
        name: "WeiXinLogin",
        replace: true,
      });
    },
    // 退出登录
    LoginOut() {
      let params = {
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
        token: localStorage.getItem('token').toString(),
      }
      logout(params).then((res) => {
        console.log('退出登录结果：', res)
        if (res.data.code == 200) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        }
        else {
          this.$message.error('退出登录失败！')
        }
      })
    },
    // 计算页数的方法
    calcPageData() {
      // 计算页数，根据后台数据的条数和每页要显示的数量算出一共多少页，得0时设为1
      if (this.List.length > 1) {
        this.pageNum = Math.ceil(this.List.length / this.pageSize) || 1;
        // console.log("总页数：" + this.pageNum);
      }
      //数据分组
      for (let i = 0; i < this.pageNum; i++) {
        // 每页相当于一个数据，例如：[[],[],[]]
        // 根据每页显示数量，将后台的数据分割到每一页，假设pageSize为5，则第一也为1-5条slice(0,5),slice(5,10)...
        this.PageData[i] = this.List.slice(this.pageSize * i, this.pageSize * (i + 1));
      }

      // 获取到数据后显示第一页内容，数组下标是从0开始的，这里一定 要减去1，不然会丢失一组数据
      this.dataShow = this.PageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // 重新计算页数并分组
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 注意数组是从0开始，页码别忘了减去1
      this.dataShow = this.PageData[val - 1];
    },
    // 
    toPerson() {
      this.$router.push({ name: 'Personal' })
    },
    toMyMaterials() {
      this.$router.push({ name: 'MyMaterials' })
    }
  },
};
</script>
<style scoped>
.cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
}

.banner {
  /* height: 155px; */
  background-size: 100% auto;
  position: absolute;
  top: 150px;
}

.top-title {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
}

.row_menu {
  display: flex;
  justify-content: flex-start;
  height: 40px;
  border-bottom: 2px solid #e4e7ed;
  align-items: center;
  margin-bottom: 30px;
}

.row_menu_item_active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.row_menu_item {
  width: 100px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  font-weight: bold;
}

.row_menu_item:hover {
  color: #409eff;
}

.userMenu {
  position: initial;
}
</style>